// extracted by mini-css-extract-plugin
export default {"container":"OnBoardingPageA_container__NJeZh","containerText":"OnBoardingPageA_containerText__TWMJC","animation":"OnBoardingPageA_animation__YxS16"};